import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function SuccessStateV2({
  message,
  action,
  className,
}: {
  message: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      role="status"
      className={cn(
        "v2-motion-state-fade rounded-[var(--v2-radius-md)] border border-[var(--v2-success-border)] bg-[var(--v2-success-bg)] px-4 py-3 text-sm text-[var(--v2-success-text)]",
        className
      )}
    >
      <p>{message}</p>
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
